function createLazyModuleLoader(importModule) {
  let loadedModule = null;
  let pendingLoad = null;

  return function loadModule() {
    if (loadedModule) return Promise.resolve(loadedModule);
    if (!pendingLoad) {
      pendingLoad = importModule()
        .then(module => {
          loadedModule = module;
          return module;
        })
        .finally(() => {
          pendingLoad = null;
        });
    }
    return pendingLoad;
  };
}

const loadBomDialog = createLazyModuleLoader(
  () => import('../bom/bom.js?v=20260903c')
);
const loadBugReportDialog = createLazyModuleLoader(
  () => import('../ui/bug_report_modal.js?v=20260817b')
);
const loadDossierDialog = createLazyModuleLoader(
  () => import('../ui/dossier_modal.js?v=20260904f')
);
const loadUserAdminDialog = createLazyModuleLoader(
  () => import('../user/user_admin_modal.js?v=20260903c')
);
const loadSaveAsOrderDialog = createLazyModuleLoader(
  () => import('../ui/save_as_order_modal.js?v=20260904f')
);
const loadUserQuickCreateDialog = createLazyModuleLoader(
  () => import('../user/user_quick_create_modal.js?v=20260817b')
);
const loadHeaderAdminDialog = createLazyModuleLoader(
  () => import('./header_admin_modal.js?v=20260717a')
);
const loadToolbarAdminDialog = createLazyModuleLoader(
  () => import('./toolbar_admin_modal.js?v=20260904f')
);
const loadOrderUpdateDialog = createLazyModuleLoader(
  () => import('./order_update_modal.js')
);
const loadColorCatalogAdminDialog = createLazyModuleLoader(
  () => import('./color_catalog_admin_modal.js?v=20260720a')
);
const loadAssetDownloadDialog = createLazyModuleLoader(
  () => import('./asset_download_modal.js?v=20260722a')
);
const loadLanguageAdminDialog = createLazyModuleLoader(
  () => import('./language_admin_modal.js?v=20260730c')
);
const loadContextMenuAdminDialog = createLazyModuleLoader(
  () => import('./context_menu_admin_modal.js?v=20260723a')
);
const loadProductMasterAdminDialog = createLazyModuleLoader(
  () => import('./product_master_admin_modal.js?v=20260730b')
);
const loadPrintPlanDialog = createLazyModuleLoader(
  () => import('../print/print_plan_modal.js?v=20260904f')
);
const loadPrintSettingsAdminDialog = createLazyModuleLoader(
  () => import('./print_settings_admin_modal.js?v=20260724a')
);
const loadAssetObjectImportDialog = createLazyModuleLoader(
  () => import('./asset_object_import_modal.js?v=20260820b')
);
const loadMessageSettingsAdminDialog = createLazyModuleLoader(
  () => import('./message_settings_admin_modal.js?v=20260806a')
);
const loadInfosAdminDialog = createLazyModuleLoader(
  () => import('./infos_admin_modal.js?v=20260810a')
);
const loadInformationDialog = createLazyModuleLoader(
  () => import('./information_modal.js?v=20260810a')
);
const loadStatisticsAdminDialog = createLazyModuleLoader(
  () => import('./statistics_admin_modal.js?v=20260903a')
);
const loadCustomerMasterAdminDialog = createLazyModuleLoader(
  () => import('./customer_master_admin_modal.js?v=20260903c')
);
const loadCatalogReleaseAdminDialog = createLazyModuleLoader(
  () => import('./catalog_release_admin_modal.js?v=20261006a')
);
const loadWhatsNewDialog = createLazyModuleLoader(
  () => import('./whats_new_modal.js?v=20261006a')
);

export async function openBomModal(...args) {
  const module = await loadBomDialog();
  return module.openBomModal(...args);
}

export async function openBugReportModal(...args) {
  const module = await loadBugReportDialog();
  return module.openBugReportModal(...args);
}

export async function openDossierModal(...args) {
  const module = await loadDossierDialog();
  return module.openDossierModal(...args);
}

export async function openUserAdminModal(...args) {
  const module = await loadUserAdminDialog();
  return module.openUserAdminModal(...args);
}

export async function openSaveAsOrderModal(...args) {
  const module = await loadSaveAsOrderDialog();
  return module.openSaveAsOrderModal(...args);
}

export async function openUserQuickCreateModal(...args) {
  const module = await loadUserQuickCreateDialog();
  return module.openUserQuickCreateModal(...args);
}

export async function openHeaderAdminModal(...args) {
  const module = await loadHeaderAdminDialog();
  return module.openHeaderAdminModal(...args);
}

export async function openToolbarAdminModal(...args) {
  const module = await loadToolbarAdminDialog();
  return module.openToolbarAdminModal(...args);
}

export async function openOrderUpdateModal(...args) {
  const module = await loadOrderUpdateDialog();
  return module.openOrderUpdateModal(...args);
}

export async function openColorCatalogAdminModal(...args) {
  const module = await loadColorCatalogAdminDialog();
  return module.openColorCatalogAdminModal(...args);
}

export async function openAssetDownloadModal(...args) {
  const module = await loadAssetDownloadDialog();
  return module.openAssetDownloadModal(...args);
}

export async function openLanguageAdminModal(...args) {
  const module = await loadLanguageAdminDialog();
  return module.openLanguageAdminModal(...args);
}

export async function openContextMenuAdminModal(...args) {
  const module = await loadContextMenuAdminDialog();
  return module.openContextMenuAdminModal(...args);
}

export async function openProductMasterAdminModal(...args) {
  const module = await loadProductMasterAdminDialog();
  return module.openProductMasterAdminModal(...args);
}

export async function openPrintPlanModal(...args) {
  const module = await loadPrintPlanDialog();
  return module.openPrintPlanModal(...args);
}

export async function openPrintSettingsAdminModal(...args) {
  const module = await loadPrintSettingsAdminDialog();
  return module.openPrintSettingsAdminModal(...args);
}

export async function openAssetObjectImportModal(...args) {
  const module = await loadAssetObjectImportDialog();
  return module.openAssetObjectImportModal(...args);
}

export async function openMessageSettingsAdminModal(...args) {
  const module = await loadMessageSettingsAdminDialog();
  return module.openMessageSettingsAdminModal(...args);
}

export async function openInfosAdminModal(...args) {
  const module = await loadInfosAdminDialog();
  return module.openInfosAdminModal(...args);
}

export async function openInformationModal(...args) {
  const module = await loadInformationDialog();
  return module.openInformationModal(...args);
}

export async function openStatisticsAdminModal(...args) {
  const module = await loadStatisticsAdminDialog();
  return module.openStatisticsAdminModal(...args);
}

export async function openCustomerMasterAdminModal(...args) {
  const module = await loadCustomerMasterAdminDialog();
  return module.openCustomerMasterAdminModal(...args);
}

const loadSystemOptionsAdminDialog = createLazyModuleLoader(
  () => import('./system_options_admin_modal.js')
);
export async function openSystemOptionsAdminModal(...args) {
  const module = await loadSystemOptionsAdminDialog();
  return module.openSystemOptionsAdminModal(...args);
}

export async function openCatalogReleaseAdminModal(...args) {
  const module = await loadCatalogReleaseAdminDialog();
  return module.openCatalogReleaseAdminModal(...args);
}

export async function openWhatsNewModal(...args) {
  const module = await loadWhatsNewDialog();
  return module.openWhatsNewModal(...args);
}
